import { RootState } from 'store/types';
import { IBibleSliceState, ICurrentBook } from 'store/slices/bibleTranslationsSlice/types';

export const getBibleTrState = (state: RootState): IBibleSliceState => state.bibleTranslations;

export const getCurrentBook = (state: RootState): ICurrentBook => getBibleTrState(state).currentBook;
export const getCurrentChapter = (state: RootState): number => getBibleTrState(state).currentChapter;
export const getCurrentVerseNumber = (state: RootState): number => getBibleTrState(state).currentVerse;
export const getBibleTranslationsIds = (state: RootState): (number | string)[] => getBibleTrState(state).currentTranslations;
